<template>
  <div>
    <v-dialog width="500">
      <template v-slot:activator="{ props }">
        <div
          class="floating-btn-container"
          :style="{ right: floatingBtnRight }"
        >
          <v-btn
            v-bind="props"
            :text="lang('contactContactUs')"
            size="large"
            class="dialog-btn text-white text-capitalize font-weight-bold rounded-t-lg"
            elevation="0"
          >
          </v-btn>

          <v-btn
            :href="
              token
                ? `${mySPILURL}/AuthMiddleware/submitloginsso?ts=${token}`
                : mySPILURL
            "
            target="_blank"
            :text="lang('book_service')"
            size="large"
            class="dialog-btn text-white text-capitalize font-weight-bold rounded-t-lg"
            elevation="0"
            @click="
              () => {
                const params = {
                  action: 'CLICK BOOK OUR SERVICE',
                  remark:
                    'Click the floating button to be redirected to MY SPIL',
                  val1: null,
                  val2: null,
                  val3: mySPILURL,
                  val4: null,
                  val5: null,
                };

                saveTrackAnalytics(params);
              }
            "
          >
          </v-btn>
        </div>
      </template>

      <template v-slot:default="{ isActive }">
        <v-card class="rounded-xl pa-3 pa-sm-6" color="#f9f9f9">
          <v-card-title class="text-h5 text-text-default">
            {{ lang("contactContactUs") }}
          </v-card-title>

          <v-form @submit.prevent v-model="formValid" ref="formRef">
            <v-card-text>
              <div v-for="(content, idx) in contents" :key="idx">
                <div
                  v-show="
                    content &&
                    (!['route', 'serviceType'].includes(content.key) ||
                      (['route', 'serviceType'].includes(content.key) &&
                        [2, 3].includes(forms.purpose)))
                  "
                >
                  <div class="font-weight-bold text-text-default mb-2">
                    {{ lang(content.label) }}
                  </div>

                  <!-- Necessity -->
                  <v-select
                    v-if="content.key == 'purpose'"
                    variant="outlined"
                    v-model="forms[content.key]"
                    :rules="rules[content.key]"
                    :items="purposeMsg"
                    item-title="description"
                    item-value="purposeid"
                    :placeholder="lang('contactFormRequirePlaceholder')"
                  />

                  <!-- Service Type -->
                  <v-select
                    v-else-if="content.key == 'serviceType'"
                    variant="outlined"
                    v-model="forms[content.key]"
                    :rules="rules[content.key]"
                    :items="serviceTypeOptions"
                    item-title="title"
                    item-value="value"
                    :placeholder="lang(content.placeholder)"
                  />

                  <!-- Route -->
                  <div v-else-if="content.key == 'route'" class="d-flex ga-4">
                    <template v-for="child in content.child" :key="child.key">
                      <v-combobox
                        variant="outlined"
                        v-model="forms[content.key][child.key]"
                        :rules="rules[child.key]"
                        :items="ports"
                        item-title="portname"
                        item-value="portid"
                        :placeholder="lang(child.placeholder)"
                        class="w-50"
                      />
                    </template>
                  </div>

                  <!-- Message -->
                  <v-textarea
                    v-else-if="content.key == 'message'"
                    variant="outlined"
                    v-model="forms[content.key]"
                    :rules="rules[content.key]"
                    :counter="4000"
                    :placeholder="lang('contactFormMessagePlaceholder')"
                  />

                  <!-- Source -->
                  <div
                    v-else-if="content.key == 'source'"
                    class="d-flex flex-column ga-4"
                  >
                    <div
                      class="text-body-2 text-text-default font-weight-bold mb-2 text-justify"
                    >
                      {{ lang("contactFormSource") }}
                    </div>

                    <!-- Loading form -->
                    <template v-if="sourceMsg.length === 0">
                      <v-row>
                        <!-- Skeleton Column 1 -->
                        <v-col cols="12">
                          <v-skeleton-loader
                            type="list-item"
                            class="mb-2 bg-transparent"
                            v-for="n in 4"
                            :key="'col1-' + n"
                          />
                        </v-col>
                      </v-row>
                    </template>

                    <!-- Source Form -->
                    <v-radio-group
                      v-if="sourceMsg.length > 0"
                      v-model="forms.selectedSource"
                      :rules="rules.source"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-radio
                            v-for="source in sourceMsg"
                            :key="source.value"
                            :label="
                              isIndonesia()
                                ? source.sourcename
                                : source.sourcename_en
                            "
                            :value="source.sourceid"
                          />

                          <!-- Other Option + Textbox -->
                          <v-radio label="Other" :value="-1" />

                          <v-text-field
                            v-model="forms.selectedOtherSource"
                            variant="outlined"
                            density="compact"
                            placeholder="Please specify the source"
                            class="mt-2"
                            :disabled="forms.selectedSource !== -1"
                            :rules="rules.sourceOther"
                          />
                        </v-col>
                      </v-row>
                    </v-radio-group>
                  </div>

                  <!-- Others -->
                  <v-text-field
                    v-else
                    variant="outlined"
                    v-model="forms[content.key]"
                    :rules="rules[content.key]"
                    :placeholder="lang(content.placeholder)"
                  />
                </div>
              </div>
            </v-card-text>

            <v-card-actions class="px-4">
              <v-btn
                :text="isIndonesia() ? 'Batal' : 'Cancel'"
                size="large"
                @click="
                  () => {
                    isActive.value = false;
                    resetForm();
                  }
                "
                class="font-weight-bold mr-4 text-secondary"
              />
              <v-btn
                type="submit"
                size="large"
                @click="submitMessage"
                class="font-weight-bold text-white bg-primary rounded-pill px-4"
                style="min-width: 150px; height: 60px"
              >
                <!-- When not loading show the text -->
                {{ loading ? "" : "Submit" }}
                <!-- When Loading hide text and show the circular progress -->
                <v-progress-circular
                  v-if="loading"
                  color="white"
                  :size="20"
                  indeterminate
                />
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </template>
    </v-dialog>

    <!-- Snackbar Notification -->
    <v-snackbar
      v-model="snackbar.model"
      :color="snackbar.status"
      :timeout="3000"
      location="top right"
    >
      <div class="text-center font-weight-bold text-body-2">
        {{ snackbar.msg }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useContactStore } from "@/stores/ContactStore";
import { useUserStore } from "@/stores/UserStore";
import { usePortStore } from "@/stores/PortStore";
import { useTrackAnalyticsStore } from "@/stores/TrackAnalyticsStore";

export default {
  name: "ContactUsDialog",
  setup() {
    const config = useRuntimeConfig();
    return { config };
  },
  data() {
    return {
      snackbar: {
        model: false,
        msg: "",
        status: "",
      },
      loading: false,
      forms: {
        name: "",
        phone: "",
        email: "",
        purpose: null,
        serviceType: null,
        message: "",
        route: {
          origin: null,
          destination: null,
        },
        selectedSource: null,
        selectedOtherSource: "",
      },
      formValid: false,
      rules: {
        name: [
          (v) =>
            !!v || (isIndonesia() ? "Nama wajib diisi" : "Name is required"),
        ],
        phone: [
          (v) =>
            !!v ||
            (isIndonesia()
              ? "Nomor telepon wajib diisi"
              : "Phone number is required"),
          (v) =>
            !v ||
            /^[0-9]*$/.test(v) ||
            (isIndonesia()
              ? "Nomor telepon harus valid"
              : "Phone number must be valid"),
        ],
        email: [
          (v) =>
            !!v || (isIndonesia() ? "Email wajib diisi" : "Email is required"),
          (v) =>
            !v ||
            /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
            (isIndonesia() ? "E-mail harus valid" : "E-mail must be valid"),
        ],
        purpose: [
          (v) =>
            !!v ||
            (isIndonesia() ? "Keperluan wajib diisi" : "Purpose is required"),
        ],
        serviceType: [
          (v) =>
            ![2, 3].includes(this.forms.purpose) ||
            !!v ||
            (isIndonesia()
              ? "Tipe pengiriman wajib dipilih"
              : "Shipment type is required"),
        ],
        origin: [
          (v) =>
            ![2, 3].includes(this.forms.purpose) ||
            !!v ||
            (isIndonesia()
              ? "Kota asal wajib diisi"
              : "Origin city is required"),
        ],
        destination: [
          (v) =>
            ![2, 3].includes(this.forms.purpose) ||
            !!v ||
            (isIndonesia()
              ? "Kota tujuan wajib diisi"
              : "Destination city is required"),
        ],
        message: [
          (v) =>
            !!v ||
            (isIndonesia() ? "Pesan wajib diisi" : "Message is required"),
          (v) =>
            v.length <= 4000 ||
            (isIndonesia()
              ? "Pesan harus kurang dari 4000 karakter"
              : "Message must be less than 4000 characters"),
        ],
        source: [
          (v) =>
            !!v ||
            (isIndonesia()
              ? "Sumber wajib dipilih"
              : "Referral source is required"),
        ],
        sourceOther: [
          (v) =>
            this.forms.selectedSource !== -1 ||
            !!v ||
            (isIndonesia()
              ? "Silakan isi sumber lainnya"
              : "Please specify other source"),
        ],
      },
      contents: [
        {
          key: "name",
          label: "contactFormName",
          placeholder: "contactFormNamePlaceholder",
        },
        {
          key: "phone",
          label: "contactFormWA",
          placeholder: "contactFormWAPlaceholder",
        },
        {
          key: "email",
          label: "contactFormEmail",
          placeholder: "contactFormEmailPlaceholder",
        },
        {
          key: "purpose",
          label: "contactFormRequire",
          placeholder: "contactFormRequirePlaceholder",
        },
        {
          key: "serviceType",
          label: "contactFormServiceType",
          placeholder: "contactFormServiceTypePlaceholder",
        },
        {
          key: "route",
          label: "contactFormRoute",
          child: [
            {
              key: "origin",
              placeholder: "contactFormRouteOrigin",
            },
            {
              key: "destination",
              placeholder: "contactFormRouteDestination",
            },
          ],
        },
        {
          key: "message",
          label: "contactFormMessage",
          placeholder: "contactFormMessagePlaceholder",
        },
        {
          key: "source",
        },
      ],
    };
  },
  watch: {
    "forms.selectedSource"(newValue) {
      if (newValue !== -1) {
        this.forms.selectedOtherSource = "";
      }
    },
  },
  computed: {
    ...mapState(useContactStore, ["purposeMsg", "sourceMsg"]),
    ...mapState(usePortStore, ["ports"]),
    ...mapState(useUserStore, ["token"]),

    serviceTypeOptions() {
      return [
        {
          title: lang("contactFormFCL"),
          value: "FCL",
        },
        {
          title: lang("contactFormLCL"),
          value: "LCL",
        },
        {
          title: lang("contactFormFTL"),
          value: "FTL",
        },
        {
          title: lang("contactFormLTL"),
          value: "LTL",
        },
        {
          title: lang("contactFormAirFreight"),
          value: "Air Freight",
        },
        {
          title: lang("contactFormOther"),
          value: "Lainnya",
        },
      ];
    },
    mySPILURL() {
      return this.config.public.myspilUrl;
    },
    isProduction() {
      return this.config.public.production;
    },
    floatingBtnRight() {
      return isIndonesia() ? "-205px" : "-175px";
    },
  },
  methods: {
    ...mapActions(useContactStore, [
      "contactUsSendEmail",
      "sendMessage",
      "sendMySpilMessage",
      "getPurpose",
      "getSource",
    ]),
    ...mapActions(usePortStore, ["getPort", "getToken"]),
    ...mapActions(useTrackAnalyticsStore, ["saveTrackAnalytics"]),

    resolvePortValue(val) {
      if (!val) return "";
      if (typeof val === "object") {
        return val.portid || val.portname || "";
      }
      const strVal = String(val).trim();
      if (!strVal) return "";

      const matchById = this.ports.find(
        (p) => String(p.portid).toLowerCase() === strVal.toLowerCase(),
      );
      if (matchById) return matchById.portid;

      const matchByName = this.ports.find(
        (p) => String(p.portname).toLowerCase() === strVal.toLowerCase(),
      );
      if (matchByName) return matchByName.portid;

      return strVal;
    },
    getPortName(val) {
      if (!val) return "";
      if (typeof val === "object") {
        return val.portname || val.portid || "";
      }
      const strVal = String(val).trim();
      if (!strVal) return "";

      const match = this.ports.find(
        (p) =>
          String(p.portid).toLowerCase() === strVal.toLowerCase() ||
          String(p.portname).toLowerCase() === strVal.toLowerCase(),
      );
      if (match) return match.portname;

      return strVal;
    },
    generateContactUsWAMessage(form) {
      let message = "";

      let originPortname = this.getPortName(form.route.origin);
      let destinationPortname = this.getPortName(form.route.destination);
      let typeLabel = form.serviceType ? ` [${form.serviceType}]` : "";

      if (form.purpose === 2) {
        message = `Hi saya ${form.name}\nMau tanya terkait Rute${typeLabel} dan Jadwal kapal dari ${originPortname} ke ${destinationPortname}.\n${form.message}`;
      } else if (form.purpose === 3) {
        message = `Hi saya ${form.name}\nMau tanya terkait harga${typeLabel} dari ${originPortname} ke ${destinationPortname}.\n${form.message}`;
      }

      return message;
    },
    encodeWaMessage(message) {
      return message.replace(/ /g, "%20").replace(/\n/g, "%0A");
    },
    openContacUsWAChat(form) {
      const whatsappNumber = "62811333799";
      const whatsappBaseUrl = `https://web.whatsapp.com/send?phone=${whatsappNumber}`;

      const rawMessage = this.generateContactUsWAMessage(form);
      const encodedMessage = this.encodeWaMessage(rawMessage);
      const finalUrl = `${whatsappBaseUrl}&text=${encodedMessage}`;

      window.open(finalUrl, "_blank");
    },
    async submitMessage() {
      const { valid } = await this.$refs.formRef.validate();

      if (valid) {
        this.loading = true;

        const payloadForms = {
          ...this.forms,
          route: {
            origin: this.resolvePortValue(this.forms.route.origin),
            destination: this.resolvePortValue(this.forms.route.destination),
          },
        };

        // Submit contact us data
        const submit = await this.sendMessage(payloadForms);
        if (submit.data?.status == "not-ok" || submit.status == "not-ok") {
          this.snackbar.msg = isIndonesia()
            ? "Gagal mengirim pesan"
            : "failed to send message";
          this.snackbar.status = "error";
          this.loading = false;
          return;
        }

        // Open redirect to WA CS
        if (submit.status == "ok" && [2, 3].includes(payloadForms.purpose)) {
          this.openContacUsWAChat(payloadForms);
        }

        // Send data through my spil
        if (!this.isProduction && [2, 3].includes(payloadForms.purpose)) {
          const res = await this.sendMySpilMessage(payloadForms);
          const code = res.data[0].code;

          window.open(`${this.mySPILURL}/Act/checkcucode?c=${code}`, "_blank");
        }

        // Prepare data to send email
        const params = {
          name: payloadForms.name,
          phone: payloadForms.phone,
          email: payloadForms.email,
          purpose: this.purposeMsg.find(
            (x) => x.purposeid == payloadForms.purpose,
          )?.description,
          serviceType: payloadForms.serviceType,
          message: payloadForms.message,
          pol: this.getPortName(payloadForms.route.origin),
          pod: this.getPortName(payloadForms.route.destination),
        };

        // Send email
        const sendEmailResp = await this.contactUsSendEmail(params);
        if (sendEmailResp?.isSuccess == "not-ok") {
          this.snackbar.msg = isIndonesia()
            ? "Gagal mengirim pesan"
            : "failed to send message";
          this.snackbar.status = "error";
          this.loading = false;
          return;
        }

        // Show snackbar
        this.snackbar.msg = isIndonesia()
          ? "Pesan telah dikirim"
          : "the message has been sent";
        this.snackbar.status = "success";
        this.snackbar.model = true;
        this.$refs.formRef.reset();
        this.resetForm();
        this.loading = false;

        // Save User Track Analytics
        const paramsTA = {
          action: "SEND CONTACT US",
          remark: "Send From Floating Contact Us",
          val1: null,
          val2: `{"email": "${params.email}", "purpose": "${params.purpose}", "serviceType": "${payloadForms.serviceType}"}`,
          val3: null,
          val4: null,
          val5: null,
        };

        this.saveTrackAnalytics(paramsTA);
        gtagReportConversion();
      }
    },
    resetForm() {
      this.forms.name = "";
      this.forms.phone = "";
      this.forms.email = "";
      this.forms.purpose = null;
      this.forms.serviceType = null;
      this.forms.message = "";
      this.forms.route.origin = null;
      this.forms.route.destination = null;
      this.forms.selectedSource = null;
      this.forms.selectedOtherSource = "";
    },
  },
  async mounted() {
    if (this.purposeMsg.length == 0) {
      await this.getPurpose();
    }

    if (this.sourceMsg.length == 0) {
      await this.getSource();
    }

    // Get port data
    const token = await this.getToken();
    const access_token = token.access_token;

    await this.getPort(access_token);
  },
};
</script>

<style scoped>
.floating-btn-container {
  position: fixed;
  /* right: -175px; */
  bottom: 30%;
  display: flex;
  transform: rotate(-90deg);
  z-index: 9999;
}
.dialog-btn {
  width: fit-content;
  background: rgba(67, 67, 67, 0.4);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(4px);
  margin: 0 8px;
}
.v-dialog {
  justify-content: right;
}
</style>
